<template>
  <div class="card-body pr-0">
    <AddPessoa :structure_item="structure_item" ref="modal-add-pessoa" />
    <ModalFormItem ref="modal-edit-pessoa" />
    <div v-if="parent_id == 0" class="text-right">
      <b-button
        v-if="$can('organizational_structure:create')"
        @click="addItem()"
        variant="info"
        class="ml-auto bt-action mb-2"
      >
        <font-awesome-icon icon="plus-circle" />
        Item
      </b-button>
    </div>
    <div v-for="(item, key) in itens_structure" :key="key">
      <b-card no-body class="mb-1">
        <b-card-header
          header-tag="header"
          class="d-flex p-1 card-header"
          role="tab"
        >
          <span>{{ item.name }}</span>
          <b-button
            @click="deleteItem(item)"
            v-if="item.num_children == 0 && $can('organizational_structure:delete')"
            size="sm"
            variant="light"
            class="mr-2 bt-action text-danger"
          >
            <font-awesome-icon icon="trash" />
            Deletar Item
          </b-button>
          <b-button
            v-if="$can('organizational_structure:edit')"
            @click="editItem(item)"
            size="sm"
            variant="light"
            class="mr-2 bt-action"
          >
            <font-awesome-icon icon="edit" />
            Editar
          </b-button>
          <b-button
            v-if="$can('organizational_structure:create')"
            @click="addPessoa(item)"
            size="sm"
            variant="light"
            class="mr-2 bt-action"
          >
            <font-awesome-icon icon="plus-circle" />
            Pessoas
          </b-button>
          <b-button
            v-if="$can('organizational_structure:create')"
            @click="addItem(item)"
            size="sm"
            variant="light"
            class="mr-2 bt-action"
          >
            <font-awesome-icon icon="plus-circle" />
            Item
          </b-button>
          <b-button v-b-toggle="accordion_id(item)" size="sm" variant="light">
            <font-awesome-icon icon="chevron-down" />
          </b-button>
        </b-card-header>
        <b-collapse :id="accordion_id(item)" visible>
          <b-card-body class="pr-0">
            <Persons
              v-if="item.legal_person || item.physical_people.length"
              :structure_item="item"
            />

            <Item :parent_id="item.id" class="pl-0" />
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import ModalFormItem from "./ModalFormItem.vue";
import Item from "./Item.vue";
import Persons from "./Persons.vue";
import AddPessoa from "./AddPessoa.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "Item",
  components: { ModalFormItem, Item, Persons, AddPessoa },
  props: {
    parent_id: {
      default: 0
    }
  },
  data: () => ({
    structure_item: null
  }),
  computed: {
    ...mapState("organizational_structures", ["tree_structure"]),
    itens_structure() {
      return this.tree_structure[this.parent_id];
    }
  },
  methods: {
    ...mapActions("organizational_structures", [
      "ActionDelete",
      "ActionTreeStructure"
    ]),
    self_id() {
      return this.parent_id + 1;
    },
    accordion_id(item) {
      return "accordion-" + item.id;
    },
    addPessoa(item) {
      this.structure_item = item;
      this.$refs["modal-add-pessoa"].show();
    },
    addItem() {
      this.$refs["modal-edit-pessoa"].show(null);
    },
    editItem(item) {
      this.$refs["modal-edit-pessoa"].show(item);
    },
    deleteItem(item) {
      if (item.num_children == 0) {
        this.$bvModal
          .msgBoxConfirm(
            "Você tem certeza que deseja excluir '" + item.name + "'?",
            {
              okVariant: "danger",
              okTitle: "SIM",
              cancelVariant: "info",
              cancelTitle: "NÃO"
            }
          )
          .then(async value => {
            if (value) {
              await this.ActionDelete({ id: item.id });
              this.ActionTreeStructure();

              this.$notifications.addNotification({
                message: "Registro removido com sucesso",
                type: "success"
              });
            }
          });
      } else {
        this.$notifications.addNotification({
          message: "Este item não pode ser excluído",
          type: "danger"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.icon-structure {
  font-size: 2em;
}

.card-header {
  .bt-action {
    opacity: 0;
    transition: all 0.3s;

    &:first-of-type {
      margin-left: auto !important;
    }
  }

  &:hover {
    .bt-action {
      opacity: 1;
    }
  }
}
</style>
